import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "custom-fields-popup"
};
var _hoisted_2 = {
  class: "custom-fields d-flex fl-col fl-j-c",
  style: {
    "width": "100%"
  }
};
var _hoisted_3 = {
  class: "headers-wrapper"
};
var _hoisted_4 = {
  class: "custom-fields-headers d-flex fl-j-c"
};
var _hoisted_5 = {
  class: "custom-fields-body d-flex fl-row"
};
var _hoisted_6 = {
  key: 0,
  class: "d-flex fl-col",
  style: {
    "padding-top": "20px",
    "padding-left": "1%",
    "width": "20%"
  }
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  class: "d-flex fl-s-b",
  style: {
    "margin-bottom": "3px"
  }
};
var _hoisted_10 = {
  class: "custom-field-name"
};
var _hoisted_11 = {
  key: 0,
  style: {
    "color": "red"
  }
};
var _hoisted_12 = {
  class: "validation-class"
};
var _hoisted_13 = {
  key: 0
};
var _hoisted_14 = {
  key: 1
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 0,
  style: {
    "width": "fit-content",
    "position": "relative"
  }
};
var _hoisted_17 = {
  style: {
    "width": "inherit",
    "height": "inherit",
    "position": "relative"
  }
};
var _hoisted_18 = ["id", "onChange"];
var _hoisted_19 = {
  style: {
    "width": "100%",
    "height": "100%",
    "border": "1px solid #dcdfe6",
    "border-radius": "3px"
  },
  class: "d-flex fl-col fl-j-c fl-a-c"
};
var _hoisted_20 = {
  key: 0,
  "data-cy": "upload-button",
  style: {
    "width": "200px",
    "text-align": "center",
    "height": "150px",
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "center"
  }
};
var _hoisted_21 = {
  key: 1,
  style: {
    "width": "inherit",
    "height": "inherit",
    "position": "relative"
  }
};
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  key: 1,
  style: {
    "color": "red"
  }
};
var _hoisted_24 = ["onClick"];
var _hoisted_25 = {
  class: "d-flex confirm-button-container",
  style: {
    "margin-top": "0px"
  }
};
var _hoisted_26 = {
  key: 3,
  style: {
    "color": "red"
  }
};
var _hoisted_27 = {
  class: "flex items-center"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  class: "flex items-center"
};
var _hoisted_30 = ["src"];
var _hoisted_31 = {
  key: 2,
  class: "radio-button-wrapper"
};
var _hoisted_32 = {
  key: 3
};
var _hoisted_33 = {
  key: 4,
  style: {
    "color": "red"
  }
};
var _hoisted_34 = {
  key: 1
};
var _hoisted_35 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-top": "15px",
    "margin-bottom": "8px"
  }
};
var _hoisted_36 = {
  class: "d-flex fl-s-b",
  style: {
    "margin-bottom": "3px"
  }
};
var _hoisted_37 = {
  class: "custom-field-name"
};
var _hoisted_38 = {
  key: 0,
  style: {
    "color": "red"
  }
};
var _hoisted_39 = {
  class: "validation-class"
};
var _hoisted_40 = {
  key: 0
};
var _hoisted_41 = {
  key: 1
};
var _hoisted_42 = {
  key: 0
};
var _hoisted_43 = {
  key: 0,
  style: {
    "width": "fit-content",
    "position": "relative"
  }
};
var _hoisted_44 = {
  style: {
    "width": "inherit",
    "height": "inherit",
    "position": "relative"
  }
};
var _hoisted_45 = ["id", "onChange"];
var _hoisted_46 = {
  style: {
    "width": "100%",
    "height": "100%",
    "border": "1px solid #dcdfe6",
    "border-radius": "3px"
  },
  class: "d-flex fl-col fl-j-c fl-a-c"
};
var _hoisted_47 = {
  key: 0,
  "data-cy": "upload-button",
  style: {
    "width": "200px",
    "text-align": "center",
    "height": "150px",
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "center"
  }
};
var _hoisted_48 = {
  key: 1,
  style: {
    "width": "inherit",
    "height": "inherit",
    "position": "relative"
  }
};
var _hoisted_49 = ["src"];
var _hoisted_50 = {
  key: 1,
  style: {
    "color": "red"
  }
};
var _hoisted_51 = ["onClick"];
var _hoisted_52 = {
  class: "d-flex confirm-button-container",
  style: {
    "margin-top": "0px"
  }
};
var _hoisted_53 = {
  key: 3,
  style: {
    "color": "red"
  }
};
var _hoisted_54 = {
  class: "flex items-center"
};
var _hoisted_55 = ["src"];
var _hoisted_56 = {
  class: "flex items-center"
};
var _hoisted_57 = ["src"];
var _hoisted_58 = {
  key: 2,
  class: "radio-button-wrapper"
};
var _hoisted_59 = {
  key: 3
};
var _hoisted_60 = {
  key: 4,
  style: {
    "color": "red"
  }
};
var _hoisted_61 = {
  class: "d-flex fl-s-b"
};
var _hoisted_62 = {
  class: "d-flex fl-a-c footer-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_vue_cropper = _resolveComponent("vue-cropper");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_option_group = _resolveComponent("el-option-group");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    "data-cy": "custom-fields-dialog",
    title: 'CUSTOM FIELDS',
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    width: "90%",
    top: "5vh"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("custom-fields.footer-text")), 1), _createElementVNode("span", null, [_createVNode(_component_el_button, {
        onClick: _ctx.hideDialog,
        class: "booking-button",
        "data-cy": "custom-fields-cancel-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        "data-cy": "custom-fields-confirm-button",
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _ctx.proceed,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading", "onClick"])])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.bookingTypeCustomFields.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.selectBookingTypeCustomFields && _ctx.selectBookingTypeCustomFields.apply(_ctx, arguments);
        }),
        class: _normalizeClass({
          selected: _ctx.displayedCustomFieldsType === _ctx.CustomFieldType.BOOKING
        })
      }, _toDisplayString(_ctx.$t("custom-fields.booking")), 3)) : _createCommentVNode("", true), _ctx.ticketTypeCustomFields.length ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.selectTicketTypeCustomFields && _ctx.selectTicketTypeCustomFields.apply(_ctx, arguments);
        }),
        class: _normalizeClass({
          selected: _ctx.displayedCustomFieldsType === _ctx.CustomFieldType.TICKET
        })
      }, _toDisplayString(_ctx.$t("custom-fields.individual-tickets")), 3)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_ctx.showPriceCategory ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceCategoryData, function (priceCategory) {
        return _openBlock(), _createElementBlock("div", {
          key: priceCategory.categoryId + '_' + priceCategory.priceId,
          onClick: function onClick($event) {
            return _ctx.selectPriceCategory(priceCategory);
          },
          style: _normalizeStyle([{
            "margin-bottom": "10%"
          }, {
            fontWeight: _ctx.selectedPriceCategory.priceId === priceCategory.priceId && _ctx.selectedPriceCategory.categoryId === priceCategory.categoryId ? 'bold' : 'normal'
          }])
        }, [_createElementVNode("p", null, _toDisplayString(priceCategory.categoryName + " " + priceCategory.priceName), 1)], 12, _hoisted_7);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
        style: {
          "width": "100%",
          "height": "100%",
          "padding-top": "20px",
          "padding-left": "5%"
        },
        class: _normalizeClass({
          border: _ctx.showPriceCategory
        })
      }, [_ctx.computedDisplayedCustomFieldsType === _ctx.CustomFieldType.BOOKING ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingTypeCustomFields, function (cust) {
        var _ctx$results;

        return _openBlock(), _createElementBlock("div", {
          key: cust.uuid,
          class: "custom-fields-item",
          style: {
            "padding-top": "10px",
            "padding-bottom": "10px"
          }
        }, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_9, [_createElementVNode("label", _hoisted_10, [_createTextVNode(_toDisplayString(cust.customField.name) + " ", 1), cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY ? (_openBlock(), _createElementBlock("span", _hoisted_11, " * ")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_12, _toDisplayString(cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY ? _ctx.$t("custom-fields.mandatory") : _ctx.$t("custom-fields.optional")), 1)]), cust.customField.informationType === _ctx.InformationType.PHONE ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_MazPhoneNumberInput, {
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          color: "info",
          "show-code-on-list": "",
          "default-country-code": _ctx.getCountryCodeFromPhone(cust) || _ctx.userCurrentCountry,
          "list-position": "top left",
          onUpdate: _cache[2] || (_cache[2] = function ($event) {
            return _ctx.results = $event;
          }),
          success: (_ctx$results = _ctx.results) === null || _ctx$results === void 0 ? void 0 : _ctx$results.isValid,
          size: "md"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "default-country-code", "success"])])) : cust.customField.questionType !== _ctx.QuestionType.LIST && cust.customField.questionType !== _ctx.QuestionType.RADIO ? (_openBlock(), _createElementBlock("div", _hoisted_14, [cust.customField.questionType === _ctx.QuestionType.FILE ? (_openBlock(), _createElementBlock("div", _hoisted_15, [!cust.fileUrl
        /*No file yet, we show the input*/
        || cust.isCropped
        /*there is cropped file we preview it*/
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("label", null, [_createElementVNode("div", _hoisted_17, [!cust.fileUrl ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          style: {
            "opacity": "0",
            "height": "1px",
            "position": "absolute"
          },
          id: cust.uuid,
          "data-cy": "file-input",
          type: "file",
          name: "resume",
          ref_for: true,
          ref: cust.uuid,
          accept: "image/*",
          onChange: function onChange($event) {
            return _ctx.handleFileUpload($event, cust.uuid, _ctx.CustomFieldType.BOOKING);
          }
        }, null, 40, _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [!cust.fileUrl ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Upload file ")) : _createCommentVNode("", true), cust.fileUrl && cust.isCropped ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("img", {
          style: {
            "width": "130px",
            "height": "inherit",
            "object-fit": "cover"
          },
          src: cust.fileUrl,
          alt: "File uploaded"
        }, null, 8, _hoisted_22)])) : _createCommentVNode("", true)]), cust.isInvalid ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(cust.validationMessage), 1)) : _createCommentVNode("", true)])]), cust.fileUrl ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: function onClick($event) {
            return _ctx.removeFile(cust);
          },
          style: {
            "position": "absolute",
            "bottom": "6px",
            "right": "4px",
            "height": "25px",
            "width": "25px",
            "border-radius": "50%",
            "padding": "5px",
            "cursor": "pointer",
            "background-color": "whitesmoke",
            "display": "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center"
          }
        }, [_createVNode(_component_SvgIcon, {
          iconContent: _ctx.binIcon,
          iconAlt: _ctx.binAlt,
          iconStyle: _ctx.binIconStyle
        }, null, 8, ["iconContent", "iconAlt", "iconStyle"])], 8, _hoisted_24)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), cust.fileUrl && cust.customField.informationType === _ctx.InformationType.PASSPORT && !cust.isCropped ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: {
            "width": "50%",
            "height": "50vh",
            "margin-bottom": "50px",
            "display": "flex"
          },
          ref_for: true,
          ref: cust.uuid + '_cropper_parent'
        }, [_createElementVNode("div", null, [cust.fileUrl ? (_openBlock(), _createBlock(_component_vue_cropper, {
          key: 0,
          style: {
            "width": "inherit",
            "height": "inherit",
            "max-height": "50vh"
          },
          "data-cy": "image-cropper",
          ref_for: true,
          ref: cust.uuid + '_cropper',
          "aspect-ratio": 3.5 / 4.5,
          src: cust.fileUrl,
          "view-mode": 2
        }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
          onClick: function onClick($event) {
            return _ctx.cancelCroppedPicture(cust);
          },
          type: "danger",
          class: "crop-button",
          "data-cy": "cropper-remove-button"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(_ctx.$t("button.remove")), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          onClick: function onClick($event) {
            return _ctx.confirmCroppedPicture(cust);
          },
          type: "primary",
          class: "crop-button",
          "data-cy": "cropper-confirm-button"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
          }),
          _: 2
        }, 1032, ["onClick"])])], 512)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.TEXT && cust.customField.informationType !== _ctx.InformationType.COUNTRY && cust.customField.informationType !== _ctx.InformationType.EMAIL ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          placeholder: cust.customField.answerExample || '',
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          }
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.TEXT && cust.customField.informationType !== _ctx.InformationType.COUNTRY && cust.customField.informationType === _ctx.InformationType.EMAIL ? (_openBlock(), _createBlock(_component_el_input, {
          key: 2,
          placeholder: cust.customField.answerExample || '',
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          class: _normalizeClass({
            'danger-email': cust.answer && _ctx.isEmailValid(cust).isValid === false
          })
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"])) : _createCommentVNode("", true), cust.answer && _ctx.isEmailValid(cust).isValid === false ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("custom-fields.invalid-email")), 1)) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.LONG_TEXT ? (_openBlock(), _createBlock(_component_el_input, {
          key: 4,
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          rows: 2,
          type: "textarea",
          placeholder: cust.customField.answerExample || ''
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : cust.customField.informationType === _ctx.InformationType.COUNTRY ? (_openBlock(), _createBlock(_component_el_select, {
          key: 5,
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          filterable: "",
          clearable: "",
          "filter-method": _ctx.countryFilter,
          placeholder: _ctx.$t('custom-fields.select-country'),
          class: "w-full",
          onVisibleChange: _ctx.handleCountryDropdownVisibility
        }, {
          default: _withCtx(function () {
            return [_ctx.showFrequentlySelected ? (_openBlock(), _createBlock(_component_el_option_group, {
              key: 0,
              label: _ctx.$t('custom-fields.frequently-selected')
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequentlySelectedCountries, function (item) {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.key,
                    label: item.value,
                    value: item.key
                  }, {
                    default: _withCtx(function () {
                      return [_createElementVNode("span", _hoisted_27, [_createElementVNode("img", {
                        src: _ctx.getFlagUrl(item.key),
                        class: "w-5 h-5 mr-2",
                        alt: "flag"
                      }, null, 8, _hoisted_28), _createTextVNode(" " + _toDisplayString(item.value), 1)])];
                    }),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))];
              }),
              _: 1
            }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_option_group, {
              label: _ctx.$t('custom-fields.all-countries')
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountriesList, function (item) {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.key,
                    label: item.value,
                    value: item.key
                  }, {
                    default: _withCtx(function () {
                      return [_createElementVNode("span", _hoisted_29, [_createElementVNode("img", {
                        src: _ctx.getFlagUrl(item.key),
                        class: "w-5 h-5 mr-2",
                        alt: "flag"
                      }, null, 8, _hoisted_30), _createTextVNode(" " + _toDisplayString(item.value), 1)])];
                    }),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))];
              }),
              _: 1
            }, 8, ["label"])];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "filter-method", "placeholder", "onVisibleChange"])) : cust.customField.informationType === _ctx.InformationType.LANGUAGE ? (_openBlock(), _createBlock(_component_el_select, {
          key: 6,
          style: {
            "width": "100%"
          },
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          placeholder: "Select",
          size: "large"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesList(cust.customField.list), function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.value,
                value: item.key
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])) : cust.customField.questionType === _ctx.QuestionType.DROPDOWN ? (_openBlock(), _createBlock(_component_el_select, {
          key: 7,
          style: {
            "width": "100%"
          },
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          placeholder: "Select",
          size: "large"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item,
                size: "large"
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])) : cust.customField.questionType === _ctx.QuestionType.DATE ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 8,
          style: {
            "width": "100%"
          },
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          },
          type: "date",
          placeholder: "Pick a date",
          "default-value": new Date(1990, 1, 1)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "default-value"])) : _createCommentVNode("", true)])) : cust.customField.questionType === _ctx.QuestionType.RADIO ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_radio_group, {
          modelValue: cust.answer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.answer = $event;
          }
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
              return _openBlock(), _createBlock(_component_el_radio, {
                label: item,
                key: item
              }, null, 8, ["label"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : cust.customField.questionType === _ctx.QuestionType.LIST ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_checkbox_group, {
          modelValue: cust.listAnswer,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return cust.listAnswer = $event;
          }
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
              return _openBlock(), _createBlock(_component_el_checkbox, {
                label: item,
                key: item
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.stripHtml(item)), 1)];
                }),
                _: 2
              }, 1032, ["label"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), !cust.answer && cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY && _ctx.canValidate ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("custom-fields.required-field")), 1)) : _createCommentVNode("", true)])]);
      }), 128))])) : _createCommentVNode("", true), _ctx.computedDisplayedCustomFieldsType === _ctx.CustomFieldType.TICKET ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedTicketTypeCustomFieldsByPSS.filter(function (groupedF) {
        return groupedF.customFields.some(function (cust) {
          return cust.priceId === _ctx.selectedPriceCategory.priceId && cust.categoryId === _ctx.selectedPriceCategory.categoryId;
        }) === true;
      }), function (groupedFields, index) {
        return _openBlock(), _createElementBlock("div", {
          key: groupedFields.pssUuid,
          class: "custom-fields-item",
          style: {
            "padding-top": "10px",
            "padding-bottom": "10px"
          }
        }, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_35, " Ticket " + _toDisplayString(index + 1), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedFields.customFields, function (cust) {
          var _ctx$results2;

          return _openBlock(), _createElementBlock("div", {
            key: cust.priceId + '_' + cust.categoryId,
            style: {
              "margin-bottom": "10px"
            }
          }, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_36, [_createElementVNode("label", _hoisted_37, [_createTextVNode(_toDisplayString(cust.customField.name), 1), cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY ? (_openBlock(), _createElementBlock("span", _hoisted_38, " * ")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_39, _toDisplayString(cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY ? "Mandatory" : "Optional"), 1)]), cust.customField.informationType === _ctx.InformationType.PHONE ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_MazPhoneNumberInput, {
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            color: "info",
            "show-code-on-list": "",
            "default-country-code": _ctx.getCountryCodeFromPhone(cust) || _ctx.userCurrentCountry,
            "list-position": "top left",
            onUpdate: _cache[3] || (_cache[3] = function ($event) {
              return _ctx.results = $event;
            }),
            success: (_ctx$results2 = _ctx.results) === null || _ctx$results2 === void 0 ? void 0 : _ctx$results2.isValid,
            size: "md"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "default-country-code", "success"])])) : cust.customField.questionType !== _ctx.QuestionType.LIST && cust.customField.questionType !== _ctx.QuestionType.RADIO ? (_openBlock(), _createElementBlock("div", _hoisted_41, [cust.customField.questionType === _ctx.QuestionType.FILE ? (_openBlock(), _createElementBlock("div", _hoisted_42, [!cust.fileUrl
          /*No file yet, we show the input*/
          || cust.isCropped
          /*there is cropped file we preview it*/
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("label", null, [_createElementVNode("div", _hoisted_44, [!cust.fileUrl ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            style: {
              "opacity": "0",
              "height": "1px",
              "position": "absolute"
            },
            id: cust.uuid,
            "data-cy": "file-input",
            type: "file",
            name: "resume",
            ref_for: true,
            ref: cust.uuid,
            accept: "image/*",
            onChange: function onChange($event) {
              return _ctx.handleFileUpload($event, cust.uuid, _ctx.CustomFieldType.TICKET);
            }
          }, null, 40, _hoisted_45)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_46, [!cust.fileUrl ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Upload file ")) : _createCommentVNode("", true), cust.fileUrl && cust.isCropped ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("img", {
            style: {
              "width": "130px",
              "height": "inherit",
              "object-fit": "cover"
            },
            src: cust.fileUrl,
            alt: "File uploaded"
          }, null, 8, _hoisted_49)])) : _createCommentVNode("", true)]), cust.isInvalid ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(cust.validationMessage), 1)) : _createCommentVNode("", true)])]), cust.fileUrl ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            onClick: function onClick($event) {
              return _ctx.removeFile(cust);
            },
            style: {
              "position": "absolute",
              "bottom": "6px",
              "right": "4px",
              "height": "25px",
              "width": "25px",
              "border-radius": "50%",
              "padding": "5px",
              "cursor": "pointer",
              "background-color": "whitesmoke",
              "display": "flex",
              "flex-direction": "column",
              "justify-content": "center",
              "align-items": "center"
            }
          }, [_createVNode(_component_SvgIcon, {
            iconContent: _ctx.binIcon,
            iconAlt: _ctx.binAlt,
            iconStyle: _ctx.binIconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])], 8, _hoisted_51)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), cust.fileUrl && cust.customField.informationType === _ctx.InformationType.PASSPORT && !cust.isCropped ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: {
              "width": "50%",
              "height": "50vh",
              "margin-bottom": "50px",
              "display": "flex"
            },
            ref_for: true,
            ref: cust.uuid + '_cropper_parent'
          }, [_createElementVNode("div", null, [cust.fileUrl ? (_openBlock(), _createBlock(_component_vue_cropper, {
            key: 0,
            style: {
              "width": "inherit",
              "height": "inherit",
              "max-height": "50vh"
            },
            "data-cy": "image-cropper",
            ref_for: true,
            ref: cust.uuid + '_cropper',
            "aspect-ratio": 3.5 / 4.5,
            src: cust.fileUrl,
            "view-mode": 2
          }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_button, {
            onClick: function onClick($event) {
              return _ctx.cancelCroppedPicture(cust);
            },
            type: "danger",
            class: "crop-button",
            "data-cy": "cropper-remove-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.remove")), 1)];
            }),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            class: "crop-button",
            "data-cy": "cropper-confirm-button",
            onClick: function onClick($event) {
              return _ctx.confirmCroppedPicture(cust);
            }
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
            }),
            _: 2
          }, 1032, ["onClick"])])], 512)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.TEXT && cust.customField.informationType !== _ctx.InformationType.COUNTRY && cust.customField.informationType !== _ctx.InformationType.EMAIL ? (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            placeholder: cust.customField.answerExample || '',
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            }
          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.TEXT && cust.customField.informationType !== _ctx.InformationType.COUNTRY && cust.customField.informationType === _ctx.InformationType.EMAIL ? (_openBlock(), _createBlock(_component_el_input, {
            key: 2,
            placeholder: cust.customField.answerExample || '',
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            class: _normalizeClass({
              'danger-email': cust.answer && _ctx.isEmailValid(cust).isValid === false
            })
          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"])) : _createCommentVNode("", true), cust.answer && _ctx.isEmailValid(cust).isValid === false ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t("custom-fields.invalid-email")), 1)) : _createCommentVNode("", true), cust.customField.questionType === _ctx.QuestionType.LONG_TEXT ? (_openBlock(), _createBlock(_component_el_input, {
            key: 4,
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            rows: 2,
            type: "textarea",
            placeholder: cust.customField.answerExample || ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : cust.customField.informationType === _ctx.InformationType.COUNTRY ? (_openBlock(), _createBlock(_component_el_select, {
            key: 5,
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            filterable: "",
            clearable: "",
            "filter-method": _ctx.countryFilter,
            placeholder: "$t('custom-fields.select-country')",
            class: "w-full",
            onVisibleChange: _ctx.handleCountryDropdownVisibility
          }, {
            default: _withCtx(function () {
              return [_ctx.showFrequentlySelected ? (_openBlock(), _createBlock(_component_el_option_group, {
                key: 0,
                label: _ctx.$t('custom-fields.frequently-selected')
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequentlySelectedCountries, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.key,
                      label: item.value,
                      value: item.key
                    }, {
                      default: _withCtx(function () {
                        return [_createElementVNode("span", _hoisted_54, [_createElementVNode("img", {
                          src: _ctx.getFlagUrl(item.key),
                          class: "w-5 h-5 mr-2",
                          alt: "flag"
                        }, null, 8, _hoisted_55), _createTextVNode(" " + _toDisplayString(item.value), 1)])];
                      }),
                      _: 2
                    }, 1032, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_option_group, {
                label: _ctx.$t('custom-fields.all-countries')
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountriesList, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.key,
                      label: item.value,
                      value: item.key
                    }, {
                      default: _withCtx(function () {
                        return [_createElementVNode("span", _hoisted_56, [_createElementVNode("img", {
                          src: _ctx.getFlagUrl(item.key),
                          class: "w-5 h-5 mr-2",
                          alt: "flag"
                        }, null, 8, _hoisted_57), _createTextVNode(" " + _toDisplayString(item.value), 1)])];
                      }),
                      _: 2
                    }, 1032, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["label"])];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "filter-method", "onVisibleChange"])) : cust.customField.informationType === _ctx.InformationType.LANGUAGE ? (_openBlock(), _createBlock(_component_el_select, {
            key: 6,
            style: {
              "width": "100%"
            },
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            placeholder: "Select",
            size: "large"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesList(cust.customField.list), function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.value,
                  value: item.key
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : cust.customField.questionType === _ctx.QuestionType.DROPDOWN ? (_openBlock(), _createBlock(_component_el_select, {
            key: 7,
            style: {
              "width": "100%"
            },
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            placeholder: "Select",
            size: "large"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item,
                  label: item,
                  value: item,
                  size: "large"
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : cust.customField.questionType === _ctx.QuestionType.DATE ? (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 8,
            style: {
              "width": "100%"
            },
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            },
            type: "date",
            placeholder: "Pick a date",
            "default-value": new Date(1990, 1, 1)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "default-value"])) : _createCommentVNode("", true)])) : cust.customField.questionType === _ctx.QuestionType.RADIO ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createVNode(_component_el_radio_group, {
            modelValue: cust.answer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.answer = $event;
            }
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
                return _openBlock(), _createBlock(_component_el_radio, {
                  label: item,
                  key: item
                }, null, 8, ["label"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])) : cust.customField.questionType === _ctx.QuestionType.LIST ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createVNode(_component_el_checkbox_group, {
            modelValue: cust.listAnswer,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cust.listAnswer = $event;
            }
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cust.customField.list, function (item) {
                return _openBlock(), _createBlock(_component_el_checkbox, {
                  label: item,
                  key: item
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(_ctx.stripHtml(item)), 1)];
                  }),
                  _: 2
                }, 1032, ["label"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), !cust.answer && cust.customField.validation === _ctx.CustomFieldValidation.MANDATORY && _ctx.canValidate ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t("custom-fields.required-field")), 1)) : _createCommentVNode("", true)])]);
        }), 128))]);
      }), 128))])) : _createCommentVNode("", true)], 2)])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}